export const TIPO_CONTRATTO = [
  { value: "piva_forfettario", label: "P.IVA - Regime Forfettario" },
  { value: "piva_22", label: "P.IVA - 22%" },
  { value: "piva_esente", label: "P.IVA - Esente IVA" },
  { value: "co_co_co", label: "Co.Co.Co." },
  { value: "prestazione_occasionale", label: "Prestazione occasionale" },
  { value: "dipendente", label: "Lavoro dipendente" },
  { value: "altro", label: "Altro" },
];

export const contrattoLabel = (v) => TIPO_CONTRATTO.find((o) => o.value === v)?.label || (v || "").replace(/_/g, " ");

export const CATEGORIE_ALLEGATO = [
  { value: "identita", label: "Carta d'identità" },
  { value: "codice_fiscale", label: "Codice fiscale / Tessera sanitaria" },
  { value: "cv", label: "CV" },
  { value: "attestato", label: "Attestato" },
  { value: "contratto", label: "Contratto" },
  { value: "altro", label: "Altro" },
];

export const CATEGORIE_GENERICHE = [
  { value: "contratto", label: "Contratto" },
  { value: "fattura", label: "Fattura" },
  { value: "preventivo", label: "Preventivo / Offerta" },
  { value: "visura", label: "Visura camerale" },
  { value: "identita", label: "Carta d'identità" },
  { value: "cv", label: "CV" },
  { value: "attestato", label: "Attestato" },
  { value: "documento", label: "Documento" },
  { value: "altro", label: "Altro" },
];

export const allegatoLabel = (v) => [...CATEGORIE_ALLEGATO, ...CATEGORIE_GENERICHE].find((o) => o.value === v)?.label || v;

const SESSO = [{ value: "M", label: "Maschio" }, { value: "F", label: "Femmina" }];

const ANAGRAFICI = [
  { type: "heading", label: "Dati anagrafici", name: "h_anag" },
  { name: "nome", label: "Nome", type: "text" },
  { name: "cognome", label: "Cognome", type: "text" },
  { name: "cf", label: "Codice Fiscale", type: "text", hint: "Inserendo il codice fiscale si compilano data, sesso e luogo di nascita" },
  { name: "sesso", label: "Sesso", type: "select", options: SESSO },
  { name: "data_nascita", label: "Data di nascita", type: "date" },
  { type: "heading", label: "Luogo di nascita", name: "h_nascita" },
  { name: "luogo_nascita", label: "Paese / Comune", type: "text" },
  { name: "provincia_nascita", label: "Provincia", type: "text" },
  { name: "stato_nascita", label: "Stato", type: "text" },
  { type: "heading", label: "Residenza", name: "h_res" },
  { name: "residenza_comune", label: "Comune", type: "text" },
  { name: "residenza_via", label: "Via", type: "text" },
  { name: "residenza_cap", label: "CAP", type: "text" },
  { type: "heading", label: "Domicilio", name: "h_dom" },
  { name: "domicilio_comune", label: "Comune", type: "text" },
  { name: "domicilio_via", label: "Via", type: "text" },
  { name: "domicilio_cap", label: "CAP", type: "text" },
  { type: "heading", label: "Contatti e pagamenti", name: "h_contatti" },
  { name: "cellulare", label: "Cellulare", type: "text" },
  { name: "email", label: "Email", type: "text" },
];

export const PERSONA_FIELDS = [
  ...ANAGRAFICI,
  { name: "iban", label: "IBAN", type: "text" },
  { name: "banca", label: "Banca", type: "text" },
  { type: "heading", label: "Azienda e competenze", name: "h_altro" },
  { name: "azienda_id", label: "Azienda di appartenenza", type: "relation",
    relationEndpoint: "aziende", relationLabel: (o) => o.denominazione, full: true },
  { name: "competenze", label: "Competenze", type: "tags", optionKey: "competenze", full: true },
  { name: "note", label: "Note", type: "textarea", full: true },
];

export const RUOLI_PERSONALE = [{ value: "docente", label: "Docente" }, { value: "tutor", label: "Tutor" }];
export const ruoliLabel = (arr) => {
  const r = RUOLI_PERSONALE.filter((o) => (arr || []).includes(o.value));
  return (r.length ? r : [RUOLI_PERSONALE[0]]).map((o) => o.label).join(" e ");
};

export const DOCENTE_FIELDS = [
  { type: "heading", label: "Ruolo", name: "h_ruolo" },
  { name: "ruoli", label: "Ruolo (uno o entrambi)", type: "checks", options: RUOLI_PERSONALE, default: ["docente"], full: true },
  ...ANAGRAFICI,
  { name: "iban", label: "IBAN", type: "text", econ: true },
  { name: "banca", label: "Banca", type: "text" },
  { type: "heading", label: "Contratto", name: "h_contratto" },
  { name: "piva", label: "Partita IVA", type: "text" },
  { name: "tipo_contratto", label: "Tipo contratto", type: "select", options: TIPO_CONTRATTO },
  { name: "tipo_contratto_altro", label: "Altro (specificare)", type: "text", showIf: (f) => f.tipo_contratto === "altro" },
  { name: "tariffa_oraria", label: "Importo orario (€)", type: "number", econ: true },
  { name: "importo_orario_cob", label: "Importo orario COB (€)", type: "number", econ: true },
  { name: "contratto_data_inizio", label: "Data inizio COB", type: "date" },
  { name: "contratto_data_fine", label: "Data fine COB", type: "date" },
  { name: "cococo_data_fine", label: "Fine durata Co.Co.Co.", type: "date" },
  { type: "heading", label: "Competenze e disponibilità", name: "h_comp" },
  { name: "competenze", label: "Competenze", type: "tags", optionKey: "competenze", full: true },
  { name: "disponibilita", label: "Disponibilità", type: "text", full: true },
  { name: "note", label: "Note", type: "textarea", full: true },
];

const it = (d) => d.split("-").reverse().join("/");

export function cobWarning(f) {
  const ini = f.contratto_data_inizio, fine = f.contratto_data_fine, cococo = f.cococo_data_fine;
  if (ini && fine && fine < ini) return `La data fine COB (${it(fine)}) è precedente alla data inizio COB (${it(ini)}).`;
  if (fine && cococo && fine > cococo) return `La data fine COB (${it(fine)}) supera la durata del Co.Co.Co. (${it(cococo)}).`;
  return "";
}
